import React, { useState } from "react";
import Button from "../../components/Button";
import CardLayout from "../../components/CardLayout";
import Input from "../../components/Input";

const TransferFundsUserPage = () => {
  const [data, setData] = useState({
    wallet_balance: "",
    amount: "",
    txn_password: "",
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(data);
  };
  return (
    <div className="mono_transferfundsuser_page_wrapper">
      <CardLayout
        style={{ backgroundColor: "#fff" }}
        className="mono_transferfundsuser_form_card"
      >
        <div className="mono_section_title">
          <h2>Activation Wallet Transfer To User</h2>
        </div>
        <div className="mono_transferfundsuser_page_content">
          <form onSubmit={handleSubmit}>
            <div className="form_group">
              <Input
                label="Activation Wallet Address"
                type="text"
                name="wallet_balance"
                placeholder="Enter activation wallet address"
                onChange={(e) =>
                  setData({ ...data, wallet_balance: e.target.value })
                }
                className="input_field"
              />
            </div>
            <div className="form_group">
              <Input
                label="Enter Amount"
                type="text"
                name="amount"
                placeholder="Enter amount"
                onChange={(e) => setData({ ...data, amount: e.target.value })}
                className="input_field"
              />
            </div>
            <div className="form_group">
              <Input
                label="Txn Password"
                type="text"
                name="txn_password"
                placeholder="Enter txn password"
                onChange={(e) =>
                  setData({ ...data, txn_password: e.target.value })
                }
                className="input_field"
              />
            </div>
            <Button type="submit" className="submit_btn">
              activation wallet transfer
            </Button>
          </form>
        </div>
      </CardLayout>
    </div>
  );
};

export default TransferFundsUserPage;
